import { AdminOnly } from '@/components/admin-only'
import { createFileRoute } from '@tanstack/react-router'
import { Page, PageHeader } from '@/components/rm'
import { PriceListPanel } from '@/components/settings/price-list-panel'

export const Route = createFileRoute('/_app/pricing')({
  component: () => <AdminOnly><PricingPage /></AdminOnly>,
})

function PricingPage() {
  return (
    <Page>
      <PageHeader
        eyebrow="Sales"
        title="Price list"
        subtitle="Your rates, materials and fees. Every quote is built from this, and each line carries its cost so the margin is visible while you quote."
      />
      <PriceListPanel />
    </Page>
  )
}
